import { useEffect } from 'react';
import { isSameAddress } from '@dynamic-labs/multi-wallet';

const useSyncPrimaryWallet = ({ primaryWallet, setMultiWalletWidgetState, multiWalletWidgetState, canSync = true, }) => {
    useEffect(() => {
        if (!canSync)
            return;
        if (!primaryWallet || multiWalletWidgetState !== 'idle')
            return;
        if (primaryWallet.connector.connectedChain === 'FLOW')
            return;
        if (primaryWallet.connector.connectedChain === 'COSMOS')
            return;
        primaryWallet.connector
            .getConnectedAccounts()
            .then(([selectedAddress]) => {
            if (!selectedAddress)
                return;
            if (!isSameAddress(selectedAddress, primaryWallet.address, primaryWallet.chain)) {
                setMultiWalletWidgetState('awaiting_account_switch', 'primary_not_connected');
            }
        })
            .catch(() => {
            setMultiWalletWidgetState('awaiting_account_switch', 'primary_not_connected');
        });
    }, [
        primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.id,
        setMultiWalletWidgetState,
        multiWalletWidgetState,
        canSync,
    ]);
};

export { useSyncPrimaryWallet };
